import * as React from "react";
import { Box, IconButton, Stack, Typography } from "@mui/material";
import {
  deleteAddress,
  updatePrimaryAddress,
} from "../../../utilities/service";
import { useAuth } from "../../../hooks/AuthContext";
import useApiMutation from "../../../hooks/useApiMutation";
import { toast } from "react-toastify";
import CartAddressCard from "./CartAddressCard";
import { scrollToElement } from "../../../utilities";
import CustomModal from "../../../components/common/CustomModal";
import { NavLink } from "react-router";
import { ArrowBackIos, ArrowForwardIos } from "@mui/icons-material";
import { useEffect } from "react";
import { useState } from "react";
import { useRef } from "react";

export default function CartAddressList({
  addressList,
  setPrimaryAddress,
  primaryAddress,
  setDeliveryFeeData,
  addressListFetch,
  primaryAddressRefetch,
  selectedAddress,
  setSelectedAddress,
}) {
  const {
    user,
    addressDialogOpen,
    setAddressDialogOpen,
    newlyCreatedAddressId,
    setNewlyCreatedAddressId,
  } = useAuth();
  const [open, setOpen] = useState(false);
  const [selectedAddressId, setSelectedAddressId] = useState(null);
  const [showLeftArrow, setShowLeftArrow] = useState(false);
  const [showRightArrow, setShowRightArrow] = useState(false);
  const scrollRef = useRef();

  const { mutate } = useApiMutation({
    mutationFn: (param) => updatePrimaryAddress(param),
    options: {
      onSuccess: (data) => {
        if (!data?.error) {
          primaryAddressRefetch();
        } else {
          toast.error(data?.message);
        }
      },
      onError: (error) => {
        toast.error(error?.message);
        console.error("Error in update cart qty:", error);
      },
    },
  });
  const handlePrimaryAddress = async (address) => {
    if (address && user?.customer_id) {
      setNewlyCreatedAddressId(0);
      setSelectedAddress(address);
      scrollToContinue();
      // const param = {
      //   customerId: user?.customer_id,
      //   addressId: address?.customer_address_id,
      // };
      // mutate(param);
      // processAddressAndDeliveryDetails(address);
    }
  };
  const scrollToContinue = () => {
    const element = document.getElementById("continue-button");
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };
  const processAddressAndDeliveryDetails = (address) => {
    const { delivery_details, ...addressDetails } = address;
    setPrimaryAddress(addressDetails);
    delivery_details && setDeliveryFeeData(delivery_details);
  };
  const handleDeleteHandler = async () => {
    if (selectedAddressId) {
      const response = await deleteAddress(selectedAddressId);
      setSelectedAddressId(null);
      setOpen(false);
      if (!response?.error) {
        addressListFetch();
        toast.success(response?.message);
      } else {
        toast.error(response?.message);
      }
    }
  };
  const shouldShowArrows = addressList?.length > 2;

  const checkArrows = () => {
    const el = scrollRef.current;
    if (!el || !shouldShowArrows) return;

    setShowLeftArrow(el.scrollLeft > 0);
    setShowRightArrow(el.scrollLeft + el.clientWidth < el.scrollWidth);
  };
  const scrollLeft = () => {
    scrollRef.current.scrollBy({ left: -300, behavior: "smooth" });
  };

  const scrollRight = () => {
    scrollRef.current.scrollBy({ left: 300, behavior: "smooth" });
  };

  useEffect(() => {
    if (newlyCreatedAddressId > 0 && addressList?.length > 0) {
      const newAddress = addressList.find(
        (item) => item.customer_address_id === newlyCreatedAddressId
      );
      if (newAddress) {
        handlePrimaryAddress(newAddress);
      }
    }
    const el = scrollRef.current;
    if (!el || !shouldShowArrows) return;

    checkArrows();

    const handleScroll = () => checkArrows();
    el.addEventListener("scroll", handleScroll);
    window.addEventListener("resize", checkArrows);

    return () => {
      el.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", checkArrows);
    };
  }, [addressList]);

  return (
    <>
      {/* <Box
        sx={{
          overflowX: "auto",
          whiteSpace: "nowrap",
          scrollbarWidth: "none",
          "&::-webkit-scrollbar": { display: "none" },
          "-ms-overflow-style": "none",
        }}
      >
        <Stack direction="row" spacing={2}>
          {addressList?.map((item, index) => (
            <CartAddressCard
              key={index}
              item={item}
              selected={
                item?.customer_address_id ===
                primaryAddress?.customer_address_id
              }
              onSelect={handlePrimaryAddress}
              onDelete={() => {
                setOpen(true);
                setSelectedAddressId(item?.customer_address_id);
              }}
              onEdit={() => {
                setAddressDialogOpen(true);
                setSelectedAddressId(item?.customer_address_id);
              }}
            />
          ))}
        </Stack>
      </Box> */}
      <Box sx={{ position: "relative", my: 2 }}>
        {/* Left Arrow */}
        {shouldShowArrows && showLeftArrow && (
          <IconButton
            onClick={scrollLeft}
            sx={{
              position: "absolute",
              left: -10,
              top: "50%",
              transform: "translateY(-50%)",
              zIndex: 1,
              backgroundColor: "white",
              boxShadow: 1,
            }}
          >
            <ArrowBackIos fontSize="small" />
          </IconButton>
        )}

        {/* Scrollable Content */}
        <Box
          ref={scrollRef}
          sx={{
            overflowX: "auto",
            whiteSpace: "nowrap",
            scrollbarWidth: "none",
            "&::-webkit-scrollbar": { display: "none" },
            "-ms-overflow-style": "none",
            px: 4,
          }}
        >
          <Stack direction="row" spacing={2}>
            {addressList?.map((item, index) => (
              <CartAddressCard
                key={index}
                item={item}
                selected={
                  item?.customer_address_id ===
                  primaryAddress?.customer_address_id
                }
                onSelect={handlePrimaryAddress}
                onDelete={() => {
                  setOpen(true);
                  setSelectedAddressId(item?.customer_address_id);
                }}
                onEdit={() => {
                  setAddressDialogOpen(true);
                  setSelectedAddressId(item?.customer_address_id);
                }}
              />
            ))}
          </Stack>
        </Box>

        {/* Right Arrow */}
        {shouldShowArrows && showRightArrow && (
          <IconButton
            onClick={scrollRight}
            sx={{
              position: "absolute",
              right: -10,
              top: "50%",
              transform: "translateY(-50%)",
              zIndex: 1,
              backgroundColor: "white",
              boxShadow: 1,
            }}
          >
            <ArrowForwardIos fontSize="small" />
          </IconButton>
        )}
      </Box>
      <CustomModal
        open={open}
        setOpen={setOpen}
        title={"Delete Confirmation"}
        description={" Are you sure you want to delete this address?"}
        handleConfirm={handleDeleteHandler}
        confirmBtnLaebel={"Delete"}
        cancelBtnLabel={"Cancel"}
      />
    </>
  );
}
